module.exports = __webpack_public_path__ + "static/media/addIcon2.7b5f4a99.svg";